import { combineReducers } from 'redux';
import { adminReducer } from './adminReducer';
import { galeriaMultimediaReducer } from './galeriaMultimediaReducer';
import { noticiaReducer } from './noticiaReducer';

export const rootReducer = combineReducers({
    admin: adminReducer,
    noticia: noticiaReducer,
    galeria: galeriaMultimediaReducer,
});